import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { DialogLoadingComponent } from "../components/dialog-loading/dialog-loading.component";
import {LoadingComponent} from "../components/loading/loading.component";

@Injectable()
export class LoadingService {

    private task: number = 0;
    private modal: MatDialogRef<LoadingComponent>;

    public onLoad = new Subject<boolean>();

    constructor(
        private dialog: MatDialog
    ) { }

    public addTask(n: number = 1) {
        this.task += n;
        this.check();
    }

    public finishTask() {
        if (this.task === 0) return;

        this.task--;
        this.check();
    }

    public removeAllTasks() {
        this.task = 0;
        this.check();
    }

    private check() {
        if (this.task === 0) {
            this.closeLoadingScreen();
        } else {
            this.openLoadingScreen();
        }
    }

    private openLoadingScreen(): void {
        if (this.modal) return;

        this.modal = this.dialog.open(LoadingComponent, {
            disableClose: true,
            width: '400px',
            panelClass: 'pme-dialog-loading-panel',
            backdropClass: 'pme-dialog-loading-backdrop'
        });
    }

    private closeLoadingScreen() {
        if (!this.modal) return;

        this.modal.close();
        this.modal = null;

        this.onLoad.next(true)
    }
}
